import * as actionTypes from './actionTypes';
import * as actions from './index';

export const searchFtvContacts = (filter) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_CONTACTS_SEARCH_START });

        window.flow.ftvcontactsSearchUsers(filter).then(res => {
            dispatch({ type: actionTypes.FTV_CONTACTS_SEARCH_SUCCESS, contacts: res});
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_CONTACTS_SEARCH_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const createFtvContact = (contact) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_CONTACT_CREATE_START });

        window.flow.ftvcontactsCreateUser(contact).then(res => {
            dispatch({ type: actionTypes.FTV_CONTACT_CREATE_SUCCESS});
            dispatch(actions.searchFtvContacts());
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_CONTACT_CREATE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const editFtvContact = (contact, original) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_CONTACT_EDIT_START });

        window.flow.ftvcontactsEditUser(contact, original).then(res => {
            dispatch({ type: actionTypes.FTV_CONTACT_EDIT_SUCCESS});
            dispatch(actions.searchFtvContacts());
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_CONTACT_EDIT_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const ftvContactsSetRoom = (id) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_CONTACTS_SET_ROOM, room: id });
    };
};

export const deleteFtvContact = (contact) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_CONTACT_DELETE_START });

        window.flow.ftvcontactsDeleteUser(contact).then(res => {
            dispatch({ type: actionTypes.FTV_CONTACT_DELETE_SUCCESS});
            dispatch(actions.searchFtvContacts());
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_CONTACT_DELETE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const getFtvGroups = () => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_GROUPS_SEARCH_START });

        window.flow.ftvcontactsGetGroups({}).then(res => {
            dispatch({ type: actionTypes.FTV_GROUPS_SEARCH_SUCCESS, groups: res});
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_GROUPS_SEARCH_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const getFtvGroup = (group) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_GROUP_GET_START });

        window.flow.ftvcontactsGetGroup(group).then(res => {
            dispatch({ type: actionTypes.FTV_GROUP_GET_SUCCESS, group: res});
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_GROUP_GET_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const createFtvGroup = (group) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_GROUP_CREATE_START });
        
        window.flow.ftvcontactsCreateGroup(group).then(res => {
            dispatch({ type: actionTypes.FTV_GROUP_CREATE_SUCCESS});
            dispatch(actions.getFtvGroups());
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_GROUP_CREATE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const deleteFtvGroup = (group) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_GROUP_DELETE_START });

        window.flow.ftvcontactsDeleteGroup(group).then(res => {
            dispatch({ type: actionTypes.FTV_GROUP_DELETE_SUCCESS});
            dispatch(actions.getFtvGroups());
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_GROUP_DELETE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const saveFtvGroup = (group) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_GROUP_SAVE_START });

        window.flow.ftvcontactsEditGroup(group).then(res => {
            dispatch({ type: actionTypes.FTV_GROUP_SAVE_SUCCESS, group: group });
            dispatch(actions.getFtvGroups());
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_GROUP_SAVE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const addFtvToGroup = (gid, uid) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_GROUP_ADD_START });

        window.flow.ftvcontactsAddGroupUser({gid: gid, uid: uid}).then(res => {
            dispatch({ type: actionTypes.FTV_GROUP_ADD_SUCCESS});
            dispatch(actions.getFtvGroup({ gid: gid }));
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_GROUP_ADD_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const removeFtvFromGroup = (gid, uid) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_GROUP_REMOVE_START });

        window.flow.ftvcontactsRemGroupUser({gid: gid, uid: uid}).then(res => {
            dispatch({ type: actionTypes.FTV_GROUP_REMOVE_SUCCESS});
            dispatch(actions.getFtvGroup({ gid: gid }));
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_GROUP_REMOVE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};
